import styled from 'styled-components'

export const VelocityEarnRedeem = styled.div`
  [type='radio'] {
    display: none;
  }
  [type='radio'] + label {
    position: relative;
    padding-left: 35px;
    cursor: pointer;
    line-height: 20px;
    display: inline-block;
    color: var(--brand-secondary);
    var
  }
  [type='radio'] + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 12px;
    width: 18px;
    height: 18px;
    border: 1px solid var(--brand-secondary);
    border-radius: 100%;
    background: #fff;
  }
  [type='radio'] + label:after {
    content: '';
    width: 14px;
    height: 14px;
    background: var(--brand-secondary);
    position: absolute;
    top: 15px;
    left: 3px;
    border-radius: 100%;
    transition: all 0.2s ease;
  }
  [type='radio']:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  [type='radio']:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  [type='radio'] ~ div > p {
    margin-left: 35px;
  }
`

export const VelocityDescription = styled.p`
  line-height: 1.4;
  width: 100%;
  max-width: 460px;
  font-weight: var(--font-regular);
  font-size: 14px;
`

export const VelocityPointsCont = styled.div`
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;

  span {
    font-size: 14px;
    font-weight: var(--font-regular);
    color: #e10a0a;
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    gap: 5px;
  }
`

export const VelocityPointsAmt = styled.mark`
  background: transparent;
  color: inherit;
  font-weight: var(--font-bold);
  position: relative;
  top: 1px;
`

export const VelocityBurnCont = styled.div`
  margin-top: 30px;

  > div {
    justify-content: flex-start;
    margin-top: 15px;
  }

  .slider-value {
    font-weight: var(--font-bold);
    color: #e10a0a;
    font-size: 14px;
  }
`

export const VelocityBurnTotal = styled.p`
  font-weight: var(--font-bold);
  font-size: 14px;
  color: #e10a0a;

  span {
    color: var(--brand-secondary);
    text-transform: uppercase;
  }
`

export const Feedback = styled.div`
  font-size: 24px;
  color: grey;

  & > a {
    color: grey;
  }
`
